import { createUndefinedObject, pushDataLayer } from './utils';

interface UserData {
  id: string;
  user_id: string;
  user_name: string;
  school_id: string | number;
  school_name: string;
  role: string;
}

export const trackUserData = async (data: UserData) => {
  pushDataLayer<UserData>('userData', data);
};

export const clearUserDataLayer = () => {
  const data = createUndefinedObject<UserData>();
  pushDataLayer('clearuserData', data);
};
